import React, { PureComponent } from 'react';
import { View } from 'react-native';
import { Large } from '@dbk/ui-text';
import { createContainer } from '@dbk-legacy/muster/react';

class NoSearchResults extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { i18n: { messages } } = this.props;
    let rowLength = this.props.data.length;

    return (
      <View className="no-search-container">
        {rowLength === 0 && (
          <View className="no-search" >
            <Large id="txt_noResultPosition_noSearchResult_test" secondary>{messages['app.Search.noresultPosition']}</Large>
          </View>
        )}
      </View>
    );
  }
}

export default createContainer({
  $queries: {
    screen: {
      height: true,
    },
    i18n: {
      messages: true,
    },
  },
})(NoSearchResults);
